import { DRAWER_POSITION } from "@/constants/drawer";
import {
    REVIEWS_BRANDING_PRODUCT_AVG_RATING_DISPLAY_STYLE,
    REVIEWS_BRANDING_PRODUCT_AVG_RATING_VISIBILITY,
    REVIEWS_ICON_TYPES_LIST,
    REVIEWS_WIDGET_LAYOUT,
} from "@apps/reviews/constants";
import { REWIEWS_BRANDING_LAUNCHER_VISIBILITY_TYPES } from "@apps/reviews/types";
import { enums, literal, object, optional, string, union } from "superstruct";

const ReviewsStorefrontValuesBrandingSchema = object({
    reviewsThemeSettings: object({
        primaryColor: string(),
        secondaryColor: string(),
    }),
    reviewsIconSettings: object({
        iconType: enums(REVIEWS_ICON_TYPES_LIST),
        starColor: string(),
    }),
    reviewsWidgetsSettings: object({
        buttonsColor: union([
            literal("primaryColor"),
            literal("secondaryColor"),
        ]),
        reviewerNameDisplayFormat: optional(string()), //TODO remove after migration Nazario
        reviewsWidgetLayout: union([
            literal(REVIEWS_WIDGET_LAYOUT.LISTING_LAYOUT),
            literal(REVIEWS_WIDGET_LAYOUT.GRID_LAYOUT),
        ]),
    }),
    reviewsDrawerSettings: object({
        device: enums([
            REWIEWS_BRANDING_LAUNCHER_VISIBILITY_TYPES.allDevices,
            REWIEWS_BRANDING_LAUNCHER_VISIBILITY_TYPES.desktopOnly,
            REWIEWS_BRANDING_LAUNCHER_VISIBILITY_TYPES.hide,
        ]),
        drawerPosition: enums(Object.values(DRAWER_POSITION)),
        launcherBackgroundColor: union([
            literal("primaryColor"),
            literal("secondaryColor"),
        ]),
        launcherFontColor: string(),
        launcherIconBackgroundColor: string(),
    }),
    productAvgRatingWidgetSettings: object({
        widgetVisibility: union([
            literal(REVIEWS_BRANDING_PRODUCT_AVG_RATING_VISIBILITY.SHOW),
            literal(REVIEWS_BRANDING_PRODUCT_AVG_RATING_VISIBILITY.HIDE),
        ]),
        widgetDisplayStyle: union([
            literal(
                REVIEWS_BRANDING_PRODUCT_AVG_RATING_DISPLAY_STYLE.SHOW_TEXT_AND_STARS
            ),
            literal(
                REVIEWS_BRANDING_PRODUCT_AVG_RATING_DISPLAY_STYLE.SHOW_STARS_ONLY
            ),
            literal(
                REVIEWS_BRANDING_PRODUCT_AVG_RATING_DISPLAY_STYLE.SHOW_TEXT_STARS_AND_QUESTION
            ),
        ]),
    }),
});

export default ReviewsStorefrontValuesBrandingSchema;
